export default __webpack_public_path__ + "static/media/pending.b52c2364.svg";